import { Button, Card, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import AddRole from "../../../components/manageSubAdmin/AddRole";
import FormData from "../../../components/manageSubAdmin/Form";

const { TabPane } = Tabs;

const SubAdminForm = () => {
  const navigate = useNavigate();
  const url = window.location.pathname;
  const path = url.includes("edit");

  const [activeTabKey, setActiveTabKey] = useState("1");

  const handleTabChange = (key: string) => {
    setActiveTabKey(key);
  };

  return (
    <div style={{ padding: 50 }}>
      <Card>
        <div
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <h2>{path ? "Edit " : "Add "}Sub Admin</h2>
          <Button
            style={{
              background: "#0C163F",
              width: 100,
              height: 40,
            }}
            type="primary"
            // htmlType="submit"
            onClick={() => {
              navigate("/managesubadmins", { replace: true });
            }}
          >
            Back
          </Button>
        </div>

        {path ? (
          <FormData path={path} />
        ) : (
          <Tabs activeKey={activeTabKey} onChange={handleTabChange}>
            <TabPane tab="Add Role" key="1">
              <AddRole />
            </TabPane>
            <TabPane tab="Add Sub Admin" key="2">
              <FormData path={path} />
            </TabPane>
          </Tabs>
        )}
      </Card>
    </div>
  );
};

export default SubAdminForm;
